import { createContext } from "react";

export const UserAdminContext = createContext(null);